import React from 'react';
import { DatagridConfigurable, useListContext } from 'react-admin';

import { DatagridSkeleton } from './Datagrid';


const CustomDatagridConfigurable = ({ children, ...props }) => {
    const { isLoading } = useListContext();

    if (isLoading) {
        const columnCount = Array.isArray(children) ? children.length : 1;
        return <DatagridSkeleton columns={columnCount} rows={5} />;
    }

    return (
        <DatagridConfigurable {...props}>{children}</DatagridConfigurable>
    );
};

export default CustomDatagridConfigurable;